import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import { Box, Card } from '@material-ui/core'
import withFormState from 'src/components/aciacehighway/hocs/withFormState'
import Stepper from 'src/components/aciacehighway/Stepper'
import A6aEditPage from './A6aEditPage'
import A6aResponse from './A6aResponse.js'
import AuditLog from './AuditLog.js'


function EditPage({ history, location, onSetLoading, showNotification }) {
  const { id } = useParams()
  const { state } = location

  const [step, setStep] = useState((state?.step ? state.step : 1) - 1)
  const [ccnValue , setCCNValues ] = useState('')

  function setCCNValue(ccnValue){
    setCCNValues(ccnValue)
  }

  function renderContent(step) {
    switch (step) {
      case 0:
        return (<A6aEditPage history={history} onSetLoading={onSetLoading}
          showNotification={showNotification} id={id} setCCNValue={setCCNValue} />)
      case 1:
        return (<A6aResponse showNotification={showNotification} a6aId={id} ccnValue={ccnValue} />)
      case 2:
        return (<AuditLog showNotification={showNotification} a6aId={id} />)
    }
  }

  return (
    <Card>
      <Stepper steps={['Create A6A', 'Response Message', 'Activity Log']} activeStep={step} onSetActiveStep={(step) => setStep(step)} />
      <Box padding={2}>
        {renderContent(step)}
      </Box>
    </Card>
  );
}

export default withFormState(EditPage)